import api from '../..'

export interface NormativeParticipantsDataValidationResponse {
  participantsTotal: number
  incompleteParticipantsCount: number
}

const getNormativeParticipantsDataValidation = (courseId: number) => {
  return api
    .get<NormativeParticipantsDataValidationResponse>(
      `administration/courses/${courseId}/normative_participants_data_validation`
    )
    .then(({ data }) => data)
}

export default getNormativeParticipantsDataValidation
